export const sameDateFormatter = (dateString: string): string => {
  const utcDate = new Date(dateString);
  const day = utcDate.getUTCDate().toString().padStart(2, "0");
  const month = (utcDate.getUTCMonth() + 1).toString().padStart(2, "0");
  const year = utcDate.getUTCFullYear().toString();
  const formattedDate = `${day}-${month}-${year}`;
  return formattedDate;
};
